export const RESET = "reset";
export const UPDATE_ADTYPE = "update_adtype";
export const UPDATE_ADTYPES = "update_adtypes";
export const UPDATE_AUCTION = "update_auction";
export const UPDATE_FILTER = "update";
export const UPDATE_PROPERTY_TYPES = "update_propertytypes";
export const UPDATE_ROOMS = "update_rooms";
export const UPDATE_PRICES_FROM = "update_pricesfrom";
export const UPDATE_PRICES_TO = "update_pricesto";
export const UPDATE_SEARCH_TEXT = "update_searchtext";
export const UPDATE_ZONES = "update_zones";
export const RESET_PROPERTY_TYPES = "reset_propertytypes";
